import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './Login';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import Home from "./page/Home";
import Firma from "./page/Firma";
import Sorgulama from "./page/Sorgulama";
import PendikIthalat from "./page/PendikIthalat";
import PendikIhracat from "./page/PendikIhracat";
import YalovaIthalat from "./page/YalovaIthalat";
import YalovaIhracat from "./page/YalovaIhracat";
import Ardiye from "./page/Ardiye";
import UcretBelirle from "./page/UcretBelirle";
import EkOdeme from "./page/EkOdeme";
import Muhasebe from "./page/Muhasebe";
import FaturaBelirleme from './page/FaturaBelirleme';
import BilgiGiris from './page/BilgiGiris';
import Kullanici from './page/Kullanici';
import Fiyatlandirma from "./page/Fiyatlandirma";
import Arsiv from "./page/Arsiv";
import Goruntule from "./page/Goruntule";
import EkOdemeMuhasebe from "./page/EkOdemeMuhasebe";
import EkOdemePlakali from "./page/EkOdemePlakali";
import GemiYuklendiHepsi from "./page/GemiYuklendiHepsi";
import GemiYuklendiIhracat from "./page/GemiYuklendiIhracat";
import GemiYuklendiIthalat from "./page/GemiYuklendiIthalat";
import Zrapor from "./page/Zrapor";
import Kasa from "./page/Kasa";
import MuhasebeFirma from "./page/MuhasebeFirma";
import Gider from "./page/Gider";

ReactDOM.render((
    <Router>
        <Switch>
            <Route path="/" exact>
                <Login/>
            </Route>
            <Route path="/anasayfa" exact>
                <Home/>
            </Route>
            <Route path="/fiyatlandirma" exact>
                <Fiyatlandirma/>
            </Route>
            <Route path="/fiyatlandirma/:id" exact>
                <Fiyatlandirma/>
            </Route>
            <Route path="/arsiv" exact>
                <Arsiv/>
            </Route>
            <Route path="/goruntule/:id" exact>
                <Goruntule/>
            </Route>
            <Route path="/firma" exact>
                <Firma/>
            </Route>
            <Route path="/pendikithalat" exact>
                <PendikIthalat/>
            </Route>
            <Route path="/pendikihracat" exact>
                <PendikIhracat/>
            </Route>
            <Route path="/yalovaithalat" exact>
                <YalovaIthalat/>
            </Route>
            <Route path="/yalovaihracat" exact>
                <YalovaIhracat/>
            </Route>
            <Route path="/ardiye" exact>
                <Ardiye/>
            </Route>
            <Route path="/sorgulama" exact>
                <Sorgulama/>
            </Route>
            <Route path="/muhasebe" exact>
                <Muhasebe/>
            </Route>
            <Route path="/kullanici" exact>
                <Kullanici/>
            </Route>
            <Route path="/zrapor" exact>
                <Zrapor/>
            </Route>
            <Route path="/ekodemeplakali" exact>
                <EkOdemePlakali/>
            </Route>
            <Route path="/gemiyuklendihepsi" exact>
                <GemiYuklendiHepsi/>
            </Route>
            <Route path="/gemiyuklendiithalat" exact>
                <GemiYuklendiIthalat/>
            </Route>
            <Route path="/gemiyuklendiihracat" exact>
                <GemiYuklendiIhracat/>
            </Route>
            <Route path="/gider" exact>
                <Gider/>
            </Route>
            <Route path="/ekodemeplakali/:id" exact>
                <EkOdemePlakali/>
            </Route>
            <Route path="/faturabelirleme/:id" exact>
                <FaturaBelirleme/>
            </Route>
            <Route path="/bilgigiris/:id" exact>
                <BilgiGiris/>
            </Route>
            <Route path="/ucretbelirle/:id" exact>
                <UcretBelirle/>
            </Route>
            <Route path="/ekodememuhasebe/:id" exact>
                <EkOdemeMuhasebe/>
            </Route>
            <Route path="/ekodeme/:id" exact>
                <EkOdeme/>
            </Route>
            <Route path="/kasa" exact>
                <Kasa/>
            </Route>
            <Route path="/muhasebefirma" exact>
                <MuhasebeFirma/>
            </Route>
        </Switch>
    </Router>
), document.getElementById('root'));
